export default "__VITE_ASSET__6a738fd7__"